import * as React from 'react';
import i18n from "../../../assets/i18n";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import * as XLSX from 'xlsx';
import { Button } from 'react-admin';
import { Description } from '@mui/icons-material';


export default function MonthlyInterviewedUniqueByClient({ data: statistics }) {
  const dinamicMonthNameColumns = statistics?.column_titles ? Object.values(statistics?.column_titles) : []
  const dinamicMonthKeyColumns = statistics?.column_titles ? Object.keys(statistics?.column_titles) : []
  const avgCounter = statistics?.avg_counter ?? 12
  const from = statistics.from
  const to = statistics.to
  const clientStatisticRows = statistics?.rows ? Object.values(statistics?.rows) : []

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet([]);
    const header = ['Client Name', ...dinamicMonthNameColumns, 'Average'];
    XLSX.utils.sheet_add_aoa(worksheet, [header], { origin: 'A1' });

    clientStatisticRows.forEach(clientStats => {
      const row = [];
      row.push(clientStats?.client_name ?? '-');
      let total = 0;

      dinamicMonthKeyColumns.forEach(monthKey => {
        const year = monthKey.slice(0, 4);
        const month = monthKey.slice(4);
        let amount = 0;
        let percent = 0;

        if (year in clientStats.column_data && month in clientStats.column_data[year]) {
          amount = clientStats.column_data[year][month].employees ?? 0;
          percent = parseFloat(clientStats.column_data[year][month].percent ?? 0);
        }

        row.push(`${amount} (${percent.toFixed(2)}%)`);
        total += parseInt(amount);
      });

      row.push(Math.floor(total / avgCounter));
      XLSX.utils.sheet_add_aoa(worksheet, [row], { origin: -1 });
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Monthly Interviewed');
    XLSX.writeFile(workbook, `Monthly_Interviewed_${from}_to_${to}.xlsx`);
  };

  return (
    <>
      <Button variant="contained" onClick={exportToExcel} sx={{ marginBottom: 2 }}>
        <Description /> Exportar a Excel
      </Button>
      <TableContainer sx={{overflowY: 'auto', maxWidth: '100%'}} component={Paper}>
        <Table size="small" aria-label="a dense table" sx={{minWidth: 'max-content'}}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={avgCounter + 3} align='center'><strong>Conversiones/Meses ({from} al {to})</strong></TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              {dinamicMonthNameColumns.map(function (text) {
                return (<TableCell><strong>{text}</strong></TableCell>)
              })}
              <TableCell><strong>Average</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clientStatisticRows.map(function (clientStats) {
              let total = 0
              return (
                <TableRow>
                  <TableCell>{ clientStats?.client_name ?? '-' }</TableCell>
                  {dinamicMonthKeyColumns.map(function (monthKey) {
                    let year = monthKey.slice(0, 4)
                    let month = monthKey.slice(4)
                    let amount = 0
                    let percent = 0
                    if (year in clientStats.column_data && month in clientStats.column_data[year]) {
                      amount = clientStats.column_data[year][month].employees ?? 0
                      percent = parseFloat(clientStats.column_data[year][month].percent ?? 0)
                    }

                    total += parseInt(amount)

                    return (<TableCell>{amount} <small>{percent.toFixed(2)}%</small></TableCell>)
                  })}
                  <TableCell>{ Math.floor(total / avgCounter) }</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}